import * as React from 'react';
import { useFocused } from 'slate-react';

import EditorToolbarButton, { EditorToolbarButtonProps } from './EditorToolbarButton';

type Props = {
  onMouseDown: (e: React.SyntheticEvent) => void;
} & EditorToolbarButtonProps;

const TextEditToolbarButton: React.FC<React.PropsWithChildren<Props>> = ({ ...props }) => {
  const isFocused = useFocused();
  return <EditorToolbarButton disabled={!isFocused} {...props}></EditorToolbarButton>;
};

export default TextEditToolbarButton;
